import { createContext, useContext } from 'react';

export interface AuthManager {
  requestAuthExpirationCheck: () => Promise<void>;
  getAuthBearerToken: () => Promise<string | null>;
  requestLogoutRedirect: (redirectUri: string) => Promise<void>;
  requestLoginRedirect: () => Promise<void>;
  reportAuthActivity: () => void;
  hasAuthBeenInactiveForTooLong: (maxMinutes: number) => boolean;
  addAuthExpirationListener: (listener: () => void) => void;
  removeAuthExpirationListener: (listener: () => void) => void;
}

export const defaultValue: AuthManager = {
  requestAuthExpirationCheck: () => Promise.resolve(),
  getAuthBearerToken: () => Promise.resolve(null),
  requestLoginRedirect: () => Promise.resolve(),
  requestLogoutRedirect: () => Promise.resolve(),
  reportAuthActivity: () => {},
  hasAuthBeenInactiveForTooLong: () => false,
  addAuthExpirationListener: () => {},
  removeAuthExpirationListener: () => {},
};

const AuthManagerContext = createContext<AuthManager>(defaultValue);

export default AuthManagerContext;

export const useAuthManager = () => useContext(AuthManagerContext);
